<template>
<m-pageframe
    title="Engagement: Home"
>
<v-container>

    <v-list-item
        v-for="(item, index) in pages"
        :key="index"
        v-on:click="onClickPage(item)"
    >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
    </v-list-item>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            pages: [
                { 'title': 'Bulk Messages', 'icon': 'mdi-forum', 'page': 'admin-engagement-bulk-messages' },
                { 'title': 'Contact Request Alarms', 'icon': 'mdi-forum', 'page': 'admin-engagement-contact-request-alarm' },
            ],
        }
    },

    methods: {
        onClickPage(item) {
            this.$router.push({
                'name': item.page,
                'params' : {
                }
            });
        }
    },
}
</script>

<style lang="scss" scoped>
</style>